import { PopoverArrow } from '@radix-ui/react-popover'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

export default function SubstringPopover({
  string,
  maxLength,
}: {
  string: string
  maxLength: number
}) {
  if (string.length <= maxLength) {
    return <span>{string}</span>
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <span>{string.substring(0, maxLength)}...</span>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <PopoverArrow />
        {string}
      </PopoverContent>
    </Popover>
  )
}
